import { Component, ElementRef, OnDestroy, Renderer2, ChangeDetectionStrategy, inject, viewChild } from '@angular/core';

import { SessionProvider } from '@providers/session/session.service';

import { MenuBaseComponent } from '@components/menu-base/menu-base.component';
import { addIcons } from "ionicons";
import { closeOutline, home, barChartOutline, fileTrayFullOutline, folderOutline, location, list, repeatSharp, car, document as documentIcon, businessOutline, search, bagOutline, bus, compass, alert, star, peopleCircle, settings, logOutOutline, earth, personCircleOutline, medalOutline, peopleOutline, serverOutline, layersOutline } from "ionicons/icons";
import { IonContent, IonList, IonMenuToggle, IonItem, IonButton, IonIcon, IonLabel } from '@ionic/angular';
import { NgClass, TitleCasePipe } from '@angular/common';
import { MyMenuComponent } from '@components/menu-lat/my-menu.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'csi-mobilemenu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        IonContent,
        IonList,
        IonMenuToggle,
        IonItem,
        IonButton,
        IonIcon,
        IonLabel,
        NgClass,
        MyMenuComponent,
        TitleCasePipe,
        TranslatePipe,
    ],
})
export class MobileMenuComponent
    extends MenuBaseComponent
    implements OnDestroy {
    private sessionProvider = inject(SessionProvider);
    private renderer = inject(Renderer2);

    // Estos dos difieren del valor por defecto de MenuBaseComponent para el menu movil.
    override showSingleQueryVin = false;
    override showConsultBySiteMexico = true;

    goToRating = '';
    ratingsParam = '';
    isAuth = false;

    private readonly homeSubmenuElem = viewChild<ElementRef>('homeSubmenuElem');

    constructor() {
        super();

        this.initializeApp();

        this.subs.push(this.events.subscribe('menuLoad', () => {
            // user and time are the same arguments passed in `events.publish(user, time)`
            this.initializeMenu();
        }));
        addIcons({ closeOutline, home, barChartOutline, fileTrayFullOutline, folderOutline, location, list, repeatSharp, car, document: documentIcon, businessOutline, search, bagOutline, bus, compass, alert, star, peopleCircle, settings, logOutOutline, earth, personCircleOutline, medalOutline, peopleOutline, serverOutline, layersOutline });
    }

    onClose() {
        this.civarElems().forEach((el) => {
            el.nativeElement.style.maxHeight = '0px';
        });

        for (let index = 0; index < this.showCivarMenu().length; index++) {
            this.showCivarMenu()[index] = false;
        }

        this.events.publish('menues:close', 1);
    }

    initializeApp() {
        this.sessionProvider.load().then(() => {
            if (this.sessionProvider.isAuthenticated()) {
                this.isAuth = true;
            } else {
                this.isAuth = false;
            }
        });
    }

    initializeMenu() {
        this.storage.get('userMenu').then((data: any) => {
            if (data) {
                this.applyMenuPreferences(data);
            }
        });
    }

    protected override reloadMenu(): void {
        this.initializeMenu();
    }

    protected override isAuthenticated(): boolean {
        return this.isAuth;
    }

    protected override onRestrictedProfile(): void {
        this.showExchange = true;
        this.showShipmentRequest = true;
    }

    toggleHomeSubmenu() {
        const arrayDashboard = [
            { id: 1, bool: this.dashboardFinancieroActive },
            { id: 2, bool: this.dashboardOperativoActive },
            { id: 3, bool: this.dashboardAMDF },
            { id: 4, bool: this.dashboardMazda },
            { id: 5, bool: this.dashboardBMW },
        ];

        let activeDashboard = 0;

        arrayDashboard.forEach((dashboardItem) => {
            if (this.check(dashboardItem)) {
                activeDashboard++;
            }
        });

        if (
            arrayDashboard.every(this.check) ||
            (activeDashboard > 1 && activeDashboard <= 4)
        ) {
            this.showHomeSubmenu = !this.showHomeSubmenu;

            const homeSubmenuElem = this.homeSubmenuElem();
            this.renderer.setStyle(
                homeSubmenuElem.nativeElement,
                'maxHeight',
                this.showHomeSubmenu
                    ? homeSubmenuElem.nativeElement.scrollHeight + 'px'
                    : '0px',
            );

            this.submenuElem().nativeElement.style.maxHeight =
                this.submenuElem().nativeElement.scrollHeight +
                homeSubmenuElem.nativeElement.style.maxHeight +
                'px';
        } else {
            if (this.dashboardFinancieroActive) {
                this.goToDashboardFinanciero();
            } else if (this.dashboardOperativoActive) {
                this.goToDashboardOperativo();
            } else if (this.dashboardAMDF) {
                this.goToDashboardAMDF();
            } else if (this.dashboardMazda) {
                this.goToDashboardMazda();
            } else if (this.dashboardBMW) {
                this.goToDashboardBMW();
            }
        }
    }
}
